import React, { useMemo } from 'react'
import { List } from 'antd'
import { useTranslation } from 'react-i18next'

import { Request, RequestTicket } from 'src/types'
import { Switch, Tooltip } from 'src/components/Ant'

import { useUpdatesPendingIssueTickets } from '../util'
import { WrapOptionCancel } from '../../styles'
import TicketItem from './ticket-item'

type Props = {
  canEdit: boolean
  request: Request
}

function Vehicles({ canEdit, request }: Props) {
  const { t } = useTranslation()
  const { isTicketsPending, handleChange } =
    useUpdatesPendingIssueTickets('VEHICLE')
  const selectedVehicles = useMemo<RequestTicket[]>(
    () =>
      request.request_tickets.filter(
        requestTicketItem =>
          requestTicketItem.class_type === 'SERVICE' &&
          requestTicketItem.request_ticket_type === 'VEHICLE'
        // && requestTicketItem.status === 'EMISSION_PENDING'
      ),
    [request.request_tickets]
  )
  const canSendRequest = selectedVehicles.some(
    ({ status }) => status === 'EMISSION_PENDING'
  )
  return (
    <>
      {canSendRequest && (
        <Tooltip title="web.agencies.cancel-tickets.cancel-hint">
          <WrapOptionCancel>
            <Switch
              style={{ width: '200px' }}
              disabled={false}
              unCheckedChildren={t(
                'web.agencies.cancel-tickets.cancel-unchecked'
              )}
              checkedChildren={t('web.agencies.cancel-tickets.cancel-checked')}
              checked={isTicketsPending}
              onChange={handleChange}
            />
          </WrapOptionCancel>
        </Tooltip>
      )}
      <List
        dataSource={selectedVehicles}
        grid={{ gutter: 24, column: 2 }}
        itemLayout="vertical"
        renderItem={(request, index) => (
          <TicketItem canEdit={canEdit} key={index} item={request} />
        )}
        style={{ margin: '0 24px' }}
      />
    </>
  )
}

export default Vehicles
